import styled from 'styled-components'

// import theme from 'configs/theme'

const Styled = styled.div`
  .ant-picker {
    border-radius: 10px;
  }
`

export default Styled
